fragment OnboardingQuotesFragment on OnboardingQuotes {
    openQuote {
        id
        modalUrl
    }
}
